<template>
    <div class="content">
        <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
            <edit-schedule-adjustment>
            </edit-schedule-adjustment> 
            </div>
        </div>  
        </div>
    </div>
    </template>
    <script>
    /* eslint-disable */
    import editScheduleAdjustment from './todo-edit-schedule-adjustment'
    export default {
        components: {
            editScheduleAdjustment
        }
    }
    </script>
    <style lang="scss">
    </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-edit-schedule-adjustment.vue